"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { localePath, stripLangPrefix } from "@/i18n/config";
import { useLang } from "@/i18n/LangContext";

// Geteilter DE/EN-Switch: Desktop-Footer, mobiler Footer und Offcanvas.
// Die aktive Sprache ist bewusst kein Link (Semantik + eindeutige hrefs).
export default function LanguageSwitch({ size = 'sm' }: { size?: 'sm' | 'lg' }) {
  const lang = useLang();
  const pathname = usePathname();
  const { path: currentPath } = stripLangPrefix(pathname || '/');
  const sizeClass = size === 'lg' ? 'footer--lang-xl' : '';

  return (
    <span className={`footer--lang no-select ${sizeClass}`} aria-label="Language">
      {lang === 'de' ? (
        <span className="footer--lang-link is-active" aria-current="true">DE</span>
      ) : (
        <Link href={localePath('de', currentPath)} className="footer--lang-link">DE</Link>
      )}
      <span className="footer--lang-sep" aria-hidden="true">/</span>
      {lang === 'en' ? (
        <span className="footer--lang-link is-active" aria-current="true">EN</span>
      ) : (
        <Link href={localePath('en', currentPath)} className="footer--lang-link">EN</Link>
      )}
    </span>
  );
}
